import * as React from "react";
import i18n from "i18n";
import ProgressiveImage from "react-progressive-image";
import { observer } from "mobx-react";

import {
  Grow,
  ClickAwayListener,
  withStyles,
  Snackbar,
  Button,
  IconButton,
} from "@material-ui/core";
import {
  AccountCircle,
  Close as CloseIcon,
  Image,
  MoreHoriz,
} from "@material-ui/icons";

import { Facebook, Google } from "common/icons";
import DropdownItem from "modules/profile/components/layouts/DropdownItem";
import { LoginStore } from "modules/login/LoginStore";
import { ProfileStore } from "modules/profile/ProfileStore";

const styles = (theme) => ({
  profileContainer: {
    width: "90px",
    height: "90px",
    border: "2px solid #ABC200",
    borderRadius: "45px",
    overflow: "hidden",
    position: "relative" as any,
    userSelect: "none" as any,
  },
  profileIcon: {
    width: "86px",
    height: "86px",
    userSelect: "none" as any,
  },
  profileChange: {
    position: "absolute" as any,
    width: "86px",
    height: "86px",
    borderRadius: "43px",
    overflow: "hidden",
    backgroundColor: "rgba(0,0,0,0.7)",
    lineHeight: "96px",
    opacity: 0,
    zIndex: 2,
    color: "#fff",
    textAlign: "center" as any,
    cursor: "pointer",
    transition: "opacity 300ms ease-in",
    userSelect: "none" as any,
    "&:hover": {
      opacity: 1,
    },
  },
  containerOptions: {
    display: "table",
  },
  growPosition: {
    transform: "translate(calc(-100% + 70px), 9.5px)",
    display: "table",
  },
  imgHigh: {
    top: "-100%",
    left: 0,
    right: 0,
    bottom: "-100%",
    margin: "auto",
    width: "100%",
  },
  imgLong: {
    left: "-100%",
    top: 0,
    bottom: 0,
    right: "-100%",
    margin: "auto",
    height: "100%",
  },
});

type IProps = {
  classes: any;
};

@observer
class DropdownUploadImage extends React.Component<IProps> {
  state = {
    open: false,
    snack: false,
    message: "",
  };

  componentWillMount = () => {
    if (LoginStore.userAuth != undefined) {
      ProfileStore.url = LoginStore.userAuth.photoURL;
      ProfileStore.providerId = LoginStore.userAuth.providerId;
    }
  };
  handleSnack = (message) => {
    this.setState({ snack: true, message });
  };

  handleSnackClose = () => {
    this.setState({ snack: false });
  };

  handleToggle = () =>
    this.setState((prevState: any) => ({ open: !prevState.open }));
  handleClose = (event) => {
    if ((this.refs.profileChange as any).contains(event.target)) return;
    this.setState({ open: false });
  };

  setClassName = (node: any) => {
    if (node) {
      const { classes } = this.props;
      if (node.clientWidth > node.clientHeight)
        node.className = classes.imgLong;
      else node.className = classes.imgHigh;
    }
  };

  handleOpenInputFile = (e) => {
    (this.refs.inputFile as any).dispatchEvent(new MouseEvent("click"));
    this.killEvent(e);
  };
  handleChangeImage = (e) => {
    this.killEvent(e);
    let file = e.target.files[0];
    if (file) {
      var allowedExtensions = /(\.jpg|\.gif|\.png)$/i;
      if (!allowedExtensions.exec(file.name)) {
        e.target.value = null;
        file = null;
        this.handleSnack(i18n.library.message.errorImageFormat);
        return;
      }
      if (file.size > 512000)
        this.handleSnack(i18n.developments.exceptions.filetobig500k);
      else {
        var reader = new FileReader();
        reader.onload = () => {
          ProfileStore.url = reader.result;
          this.setState({ open: false });
        };
        reader.readAsDataURL(e.target.files[0]);
        ProfileStore.file = e.target.files[0];
        ProfileStore.providerId = "password";
      }
    }
    ProfileStore.disabledBtn = false;
  };

  handleSetAccountImage = (account) => () => {
    ProfileStore.url = ProfileStore[account].photoUrl;
    ProfileStore.file = false;
    ProfileStore.providerId = `${account}.com`;
    this.setState({ open: false });
    ProfileStore.disabledBtn = false;
  };

  killEvent = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  render() {
    const { classes } = this.props,
      { url, providerId, facebook, google } = ProfileStore;
    return (
      <div>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={this.state.snack}
          autoHideDuration={6000}
          onClose={this.handleSnackClose}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          message={<span id="message-id">{this.state.message}</span>}
          action={[
            <IconButton color="inherit" onClick={this.handleSnackClose}>
              <CloseIcon />
            </IconButton>,
          ]}
        />
        <input
          key={url}
          type="file"
          ref="inputFile"
          accept=".jpg, .gif, .png, .gif"
          onChange={this.handleChangeImage}
          style={{ display: "none" }}
        />
        <div className={classes.profileContainer}>
          <div
            ref="profileChange"
            className={classes.profileChange}
            onClick={this.handleToggle}
          >
            <Image fontSize="small" />
          </div>
          {url ? (
            <ProgressiveImage src={url as any} placeholder="tiny-image.jpg">
              {(imageUrl, loading) =>
                !loading && (
                  <img
                    src={imageUrl}
                    ref={this.setClassName}
                    style={{ position: "absolute" }}
                  />
                )
              }
            </ProgressiveImage>
          ) : (
            <AccountCircle className={classes.profileIcon} />
          )}
        </div>
        <div className={classes.growPosition}>
          <Grow
            in={this.state.open}
            style={{ transformOrigin: "right top" }}
            unmountOnExit
          >
            <div className={classes.containerOptions}>
              <ClickAwayListener onClickAway={this.handleClose}>
                <div>
                  <DropdownItem
                    text={i18n.profile.options.file}
                    Icon={MoreHoriz}
                    onClick={this.handleOpenInputFile}
                  />
                  {facebook.linked && providerId !== "facebook.com" && (
                    <DropdownItem
                      text={i18n.profile.options.facebook}
                      Icon={Facebook}
                      onClick={this.handleSetAccountImage("facebook")}
                    />
                  )}
                  {google.linked && providerId !== "google.com" && (
                    <DropdownItem
                      text={i18n.profile.options.google}
                      Icon={Google}
                      onClick={this.handleSetAccountImage("google")}
                    />
                  )}
                </div>
              </ClickAwayListener>
            </div>
          </Grow>
        </div>
      </div>
    );
  }
}
export default withStyles(styles)(DropdownUploadImage);



// WEBPACK FOOTER //
// ./src/modules/profile/components/layouts/DropdownUploadImage.tsx